// Mirror of CssfPdfHeader.jsx: logo (left) + "CURRICULUM VITAE" (right) in the
// section header.

import { Header, ImageRun, TableRow, VerticalAlign } from "docx";
import { scaleToFit } from "../../shared/wordImage";
import { cell, frac, layoutTable, para, run } from "../../shared/wordHelpers";
import { CONTENT_WIDTH } from "../../shared/wordHelpers";
import { CSSF_ACCENT, FONT_VERDANA } from "../../shared/wordTheme";

export function buildCssfHeader( { logoImage } ) {
    const leftW = frac( 0.30 );
    const rightW = CONTENT_WIDTH - leftW;

    const logoChildren = logoImage
        ? [ para( new ImageRun( { data: logoImage.data, transformation: scaleToFit( logoImage, 80, 60 ) } ), { spacing: { after: 0 } } ) ]
        : [ para( [], { spacing: { after: 0 } } ) ];

    const title = para(
        run( "CURRICULUM VITAE", { pt: 12, bold: true, color: CSSF_ACCENT, font: FONT_VERDANA } ),
        { spacing: { after: 0 } }
    );

    return new Header( {
        children: [
            layoutTable(
                [
                    new TableRow( {
                        children: [
                            cell( logoChildren, { widthTwips: leftW, valign: VerticalAlign.CENTER } ),
                            cell( [ title ], { widthTwips: rightW, valign: VerticalAlign.CENTER } ),
                        ],
                    } ),
                ],
                { columnWidths: [ leftW, rightW ] }
            ),
        ],
    } );
}
